import React from 'react';
import { Avatar, Box } from '@mui/material';

import Text from 'components/text';
import type { Artist } from 'types';

import { FONT } from '../constants';
import { getInitials } from '../get-initials';
import { artistMetaLine } from '../artist-meta-line';

interface ArtistIdentityProps {
  artist: Artist | null;
  // Name shown when the artist (or its name) is missing.
  fallbackName?: string;
  avatarSize?: number;
  nameWeight?: number;
  nameSize?: number;
  align?: 'flex-start' | 'center';
}

// Avatar + name + "Genre · Location · Listeners" meta line — the shared artist display used
// across the Collab Club admin (requests list rows, profile cards).
const ArtistIdentity: React.FC<ArtistIdentityProps> = ({
  artist,
  fallbackName = '',
  avatarSize = 40,
  nameWeight = 600,
  nameSize = FONT.lg,
  align = 'flex-start',
}) => {
  const name = artist?.name || fallbackName;
  const meta = artistMetaLine(artist);
  return (
    <Box display="flex" alignItems={align} gap={1.5}>
      <Avatar
        src={artist?.image ?? undefined}
        sx={{
          width: avatarSize,
          height: avatarSize,
          fontSize: avatarSize >= 40 ? 13 : 11,
          flexShrink: 0,
        }}
      >
        {getInitials(name || '?')}
      </Avatar>
      <Box minWidth={0}>
        <Text fontSize={nameSize} fontWeight={nameWeight}>
          {name}
        </Text>
        {meta && (
          <Text fontSize={FONT.sm} color="#64748b" marginTop="2px">
            {meta}
          </Text>
        )}
      </Box>
    </Box>
  );
};

export default ArtistIdentity;
